import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { IAdminxStore } from '../../stores';
import { CampaignInputOptionKey } from '../../apis/campaign-input-options.api';

/**
 * @param options
 * @returns
 */
export const useCampaignInputOptions = (keys: CampaignInputOptionKey[] = []) => {
	const { campaignStore } = useStores<IAdminxStore>();
	const location = useLocation();

	useEffect(() => {
		if (!keys.length) {
			return;
		}
		campaignStore.getInputOptions().fetch(keys);
	}, [location]);

	return { error: campaignStore.getInputOptions().getError(), isLoading: campaignStore.getInputOptions().getIsLoading() };
};
